import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import $api from "../../api/$api";
import {
  TCreateFindingPayload,
  TDataToken,
  TDeleteFindingPayload,
  TQueries,
  TUpdateFindingPayload
} from "./type";


// get all findings
export const getFindings = (data: TDataToken, queries: TQueries) => {
  return $api
    .get(`/insights`, { token: data.accessToken, params: { ...queries } })
    .then((response) => {
      return response;
    });
};

export const useGetFindings = (data: TDataToken, queries: TQueries, config?: {}) => {
  const {
    data: findings,
    isLoading: isFindingLoading,
    isSuccess,
    isError, 
    isFetching,
    refetch
  } = useQuery({
    staleTime: 1000 * 60 * 1,
    queryKey: ["insights", queries],
    queryFn: () => getFindings(data, queries),
    ...config as UseQueryOptions<any>
  });
  return { findings, isFindingLoading, isSuccess, isError, refetch,isFetching };
};


export const createNewFinding = (
  data: TDataToken,
  payload: TCreateFindingPayload
) => {
  return $api
    .post(`/refactor/insight`, { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useCreateFinding = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TCreateFindingPayload>
) => {
  return useMutation({
    mutationFn: (payload: TCreateFindingPayload) => createNewFinding(data, payload),
    ...config
  });
};

export const updateFinding = (
  data: TDataToken,
  payload: TUpdateFindingPayload
) => {
  return $api
    .put(`/refactor/insight`, { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useUpdateFinding = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TUpdateFindingPayload>
) => {
  return useMutation({
    mutationFn: (payload: TUpdateFindingPayload) => updateFinding(data, payload),
    ...config
  });
};

export const deleteFinding = (data: TDataToken, payload: TDeleteFindingPayload) => {
  return $api
    .delete(`/refactor/insight`, { data: { ...payload }, token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useDeleteFinding = (data: TDataToken, config?: UseMutationOptions<any, unknown, TDeleteFindingPayload>) => {
  return useMutation({
    mutationFn: (payload: TDeleteFindingPayload) => deleteFinding(data, payload),
    ...config
  });
};
